<template>
  <div class="wrapper" id="app">
    <CardForm
      :form-data="formData"
      @submit-card="submitCard"
    />
  </div>
</template>

<script>
import payment from '@/api/payment'
import company from '@/api/company'
import CardForm from '@/components/cardui/CardForm'
import generateurl from '@/api/generateurl'

export default {
  name: 'app',
  components: {
    CardForm
  },
  data () {
    return {
      formData: {
        clientCode: '',
        cardName: '',
        cardNumber: '',
        cardMonth: '',
        cardYear: '',
        cardCvv: '',
        cardCurrency: '',
        cardAmount: 0,
        cardCompany: "",
        customerref: '',
        callback: ''
      }
    }
  },
  methods: {
    getQueryData(){
      const data = this.$route.query

      if(data.token){
        generateurl.getParams(data.token).then(res => {
          if(res && res['result'] && res['data']){
            const params = res['data']
            this.formData.cardAmount = Number(params.amount || 0).toFixed(2)
            this.formData.cardCurrency = params.currency ? params.currency.toLowerCase() : ''
            this.formData.clientCode = params.customer || ''
            this.formData.customerref = params.ref || ''
            this.formData.callback = params.callback || ''
            this.getCompany(this.formData.clientCode)
          }else {
            this.$message({
              message: "URL is expire",
              type: "error",
              duration: 4 * 1000
            });
            this.$router.push('/error/404');
          }
        })
      }else{
        this.formData.cardAmount = Number(data.amount || 0).toFixed(2)
        this.formData.cardCurrency = data.currency ? data.currency.toLowerCase() : ''
        this.formData.clientCode = data.c || ''
        this.formData.customerref = data.ref || ''
        this.formData.callback = data.callback || ''
        this.getCompany(this.formData.clientCode)
      }


    },
    getCompany(customercode){
      company.getCustomer({customercode: customercode}).then(res => {
        if(res && res['result'] && res['data']){
          this.formData.cardCompany = res['data']['companyname']
        } else {
          this.$router.push('/error/404');
        }
      })
      
    },
    submitCard(formData, mainCardNumber){
      let loading = this.$loading({
        lock: true,
        text: "Submitting...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      payment.make({
        cardnumber: mainCardNumber,
        cardType: formData.cardType,
        cardName: formData.cardName,
        cardMonth: formData.cardMonth,
        cardYear: formData.cardYear,
        cardCVV: formData.cardCvv,
        amount: formData.cardAmount,
        currency: formData.cardCurrency,
        clientCode: formData.clientCode,
        customerref: formData.customerref,
        callback: formData.callback,
      }).then((response) => {
        loading.close()
        if (response.result) {
          if (response.data.step === '3dsecure') {
            this.$router.push({ name: "PaymentSecure", params: response.data.transactioncode });
          } else {
            this.$router.push({ name: "PaymentSuccess", params: response.data });
          }
        } else {
          loading.close()
          this.$message({
            message: response.message.error +  '' + response.message.code,
            type: "error",
            duration: 4 * 1000
          });
        }
      }).catch((error) => {
        loading.close()
        console.log(error)
      });
    }
  },
  created(){
    this.getQueryData()
  }
}
</script>

<style lang="scss">
@import './src/assets/css/cardui/style.scss';
</style>